import { ApplicationEnum } from "~/@types/enums";
import buildMinimalRailShell from "~/components/dock/minimalRailShell";
import { translateWithActiveLanguage } from "~/helpers/localizedText";

const benchmarkRail = buildMinimalRailShell(
	ApplicationEnum.BENCHMARK,
	[
		{
			icon: "leaderboard",
			id: "home",
			path: "/benchmark",
			title: translateWithActiveLanguage("nav.benchmark.home.label")
		}
	],
	"leaderboard"
);

export default benchmarkRail;
